export default __webpack_public_path__ + "static/media/delete.61a3afa1.png";